import styled from 'styled-components';

export const HeaderSelect = styled.div`
    .header-m {
        display:none;
    }
    // @media only screen and (max-width: 768px){
    @media only screen and (max-width: 1100px){
        .header-m {
            display:inherit;
        }
        .header-pc {
            display:none;
        }
    }
`;

// Mheaderv1
export const Mnavbar = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 360px;
    width: 100vw;
    height: 60px;
    padding: 3px 0;
    background: rgba(35, 36, 35, 0.5);
    position: fixed;

    img {
        width: auto;
        height: 100%;
    }
`;


// MHeaderV2
export const MnavbarV2 = styled.div`
    color: var(--noite-texto-nivel1b);
    --cor-fundo-MnavbarV2: ${props=>props?.background||"rgba(35, 36, 35, 0.5)"};
    & > * {filter: opacity(90%);}
    nav {
        display: flex;
        flex-direction: column;
        ${'' /* align-items: center;
        justify-content: center; */}

        position: fixed;
        ${'' /* position: {props=>props.?rolando?"fixed":""}; */}
        z-index: 28;
    }

    .mnavbarV2-menu{
        display: flex;
        align-items: center;
        justify-content: space-between;

        min-width: 320px;
        width: 100vw;
        height: 60px;
        padding: 3px 5vw;

        background-color: var(--cor-fundo-MnavbarV2);


    }

    .mnavbarV2-fundo {
        height: 60px;
    }

`;

export const Logo = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;

    width: inherit;
    height: 100%;
    max-width: ${props => props.x};
    max-height: ${props => props.y};
    ${'' /* max-height: ${props => props.size}; */}
    background-repeat: no-repeat;
    background-size: contain;
    background-image: url(${props => props.img});
`;

// MHeaderV2>> MENU
export const VoltarDiv = styled.div`

    .btn {
        padding: 10px;
        cursor: pointer;
        font-size: 1.5rem;
    }
    .btn:hover {
        color: #FFFF;
    }
    .btn:focus {
        color: blue;
    }
    .btn:active {
        transform: scale(1.4,1.4);
    }
`;

export const MenuDiv = styled(VoltarDiv)`
    ${'' /* background-color: ${props=>props.exibir?"red":"blue"}; */}
    .btn {

        ${'' /* border-radius: 25%; */}
        ${'' /* border: 1px solid; */}

        ${'' /* animation: girar90 2s; */}
        ${'' /* transition-delay: 3s; */}
        ${'' /* transition-property: transform; */}
        ${'' /* transform: ${props=>props.exibir?"rotate(90deg)":"rotate(0deg)"}; */}
        ${'' /* animation: ${props=>props.exibir?"girar90":"girar0"} 2s; */}
        animation-name: ${props=>props.exibir?"girar90":"girar0"};
        animation-duration: 2s;
        animation-timing-function: ease;
        animation-delay: 0s;
        animation-iteration-count: 1;
        animation-direction: normal;
        animation-fill-mode: forwards;
        animation-play-state: running;
    }
    @keyframes girar90 {
      to {transform: rotate(90deg);}
    }
    @keyframes girar0 {
      from {transform: rotate(90deg);}
      to {transform: rotate(0deg);}
    }
    ${'' /* @keyframes girar90 {
      100% {transform: rotate(90deg);}
    }
    @keyframes girar0 {
      0% {transform: rotate(90deg);}
      100% {transform: rotate(0deg);}
    } */}

`;

// Menu de cascata
export const Menu = styled.div`
    display: ${props=>!!props?.exibir?"flex":"none"};
    ${'' /* display: flex; */}
    justify-content: end;

    font-family: "Poppins",Helvetica,Arial,serif;
    font-style: normal;
    font-weight: 400;

    font-size: 1.7rem;
    & * {
        ${'' /* color: var(--noite-texto-nivel1b); */}
        color: inherit;
    }

    .menu-cascata {
        width: 320px;
        ${'' /* background-color: var(--noite-fundo3); */}
        background-color: var(--cor-fundo-MnavbarV2);
        text-align: center;
        position:absolute;
        right: 0;
    }
    .click {
        cursor: pointer;
    }
    ul > * {
    }
    li {
        ${'' /* padding: 0px 5px; */}
        border-bottom: aliceblue 1px outset;
    }
    a,.click {
        width: 100%;
        height: 100%;
        padding: 15px 0;

    }
    a:hover,.click:hover{
        text-shadow: #F5F500 10px 0 10px,#F5F500 -10px 0 10px;
    }

    li>ul {
        padding: 20px 0;

    }
`

export const SubMenu = styled.ul`
    display: ${props=>props.hide?"none":"initial"};
    &>* {
        ${'' /* background: #9c8a6f17; */}
        background: #271b08;
    }

`;
